import React, { FC, useState } from 'react';
import { Form, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getRouteByName } from './routes';
import { useRootStore } from '../store';
import { ButtonLogout } from '../components/common/buttons/button-logout';

type Props = {
  onLogoutClick: () => void;
};

const Header: FC<Props> = ({ onLogoutClick }) => {
  /*-------------------- Body -----------------------------------------------*/
  const { appStore } = useRootStore();
  const [expanded, setExpanded] = useState(false);

  /*-------------------- Handlers -------------------------------------------*/

  const handleLogoutClick = () => {
    setExpanded(false);
    onLogoutClick();
  };

  const handleToggle = (state: boolean) => {
    setExpanded(state);
  };

  const handleSelect = () => {
    setExpanded(false);
  };

  /*-------------------- Render ---------------------------------------------*/
  return (
    <header>
      <Navbar
        expand="sm"
        bg="dark"
        variant="dark"
        fixed="top"
        onToggle={handleToggle}
        onSelect={handleSelect}
        expanded={expanded}
      >
        <Navbar.Brand
          as={Link}
          to={getRouteByName('Home')}
          className="d-flex align-items-center text-white"
        >
          <img
            alt=""
            src={process.env.PUBLIC_URL + '/logo-32x32.png'}
            height="32"
            className="d-inline-block mx-1"
          />
          <span className="text-white">Φωτοκύκλωση Α.Ε.</span>
        </Navbar.Brand>
        <Nav className="ml-auto">
          {appStore.isLogIn && <Form>{<ButtonLogout onClick={handleLogoutClick} />}</Form>}
        </Nav>
      </Navbar>
    </header>
  );
};

export default Header;
